export default __webpack_public_path__ + "static/media/026-boat.4b371617.svg";